let nav = $(".nav");
let hamburgerMobile = $("#hamburger-mobile");
let icons = $(".hamburger_icons");


  $(window)
    .resize(function () {
      var width = $(window).width();

      if (width > 767) {
        $(".custom_select").on("keydown", function (e) {
          if (e.keyCode == 13 || e.keyCode == 38 || e.keyCode == 40) {
            $("#select2-drop-mask").click();
            $(".select2-container--open .select2-search__field").focus();
            e.preventDefault();
          }
        }); 
        
        $(".custom_select").select2();
        $(".advaced-select-wrapper .custom_select").select2({ dropdownParent: $("#advancedSearchModal") });
        $(".lastminute_select").select2({ dropdownParent: $("#myTabContent") });
        $(".accordion_select").select2({ dropdownParent: $("#accordionSearchTwo") });
        $(".search_select").select2({ dropdownParent: $("#collapseAccordionSearchOne") });
        

        $(".lastminute_dest").select2({ 
          dropdownParent: $("#lastMinuteDest"), 
          dropdownCss: {'z-index': '1000',}
        });

        $(".country_select").select2({ dropdownParent: $("#bookingStepModal") });
        $(".custom_select_sort").select2();
        
        
      }

      if (width < 992) {
        $(".header_top .wishlist").remove();
      }

      if (width > 1200) {
        if (nav.hasClass("opened")) {
          nav.removeClass("opened");
        }

        if (hamburgerMobile.hasClass("active")) {
          hamburgerMobile.removeClass("active");
        }
        if (icons.hasClass("icons-animate")) {
          icons.removeClass("icons-animate");
        }
      }
    })
    .resize();


$(document).on('select2:open', (e) => {
    const selectId = e.target.id
    $(".select2-search__field[aria-controls='select2-" + selectId + "-results']").each(function (
        key,
        value,
    ){
        value.focus();
    })
});


$(document).ready(function () {
  var hamburger = $("#hamburger");
  var hamburgerClose = $("#hamburger-close");
  let langMobile = $(".lang-mobile");
  let searchAside = $("#yachtlist");
  let searchMobileToggle = $("#aside-search-open");
  let body = $("body");

  $("a[href*=\\#]:not([href=\\#])").on("click", function () {
    if (location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
      if (target.length) {
        $("html,body").animate(
          {
            scrollTop: target.offset().top,
          },
          1000
        );
        return false;
      }
    }
  });

  //add class to modal backdrop
  $("#viewAllPhotosModal").on("show.bs.modal", function (e) {
    setTimeout(function () {
      $(".modal-backdrop").addClass("modal-backdrop--custom");
    });
  });

  //toggle search side on mobile
  searchMobileToggle.on("click", function () {
    searchAside.addClass("active-search");
    body.addClass("hidden-scroll");
  });
  $("#aside-search-close").on("click", function () {
    searchAside.removeClass("active-search");
    body.removeClass("hidden-scroll");
  });

  //tabs
  $(".nav-tabs .nav-item.nav-link").click(function () {
    $(".nav-tabs .nav-item.nav-link.active").removeClass("active");
    $(this).addClass("active");
  });

  //show yachtdetails calendar
  $(".add-date-btn").on("click", function () {
    $(".yachtdetails-calendar").toggleClass("show");
  });

  //open booking request
  $(".open-booking").each(function(index){
    $(this).on("click", function () {
      $(".custom-modal").addClass("open")
    });
  });

  $(".open-quote").each(function(index){
    $(this).on("click", function () {
      $(".custom-modal-quote").addClass("open")
    });
  });

  $(".close-quote").on("click", function () {
    $(".custom-modal-quote").removeClass("open")
  });
  


  $("#bookingRequestClose").on("click", function () {
    $(".custom-modal").removeClass("open")
  });

  // Open on desktop secondary menu
  hamburger.on("click", function () {
    icons.toggleClass("icons-animate");
    $(this).toggleClass("active");
  });

  // Open on mobile language
  langMobile.on("click", function () {
    $([".lang-list, .lang-btn"]).toggleClass("active-lang");
  });

  // Open on mobile primary menu
  hamburgerMobile.on("click", function () {
    if ($(this).hasClass("active")) {
      nav.removeClass("opened");
      icons.removeClass("icons-animate");
      $(this).removeClass("active");
      $("body").removeClass("nav-open");
      $(".header").removeClass("header-absolute");
    } else {
      nav.addClass("opened");
      icons.addClass("icons-animate");
      $(this).addClass("active");
      $("body").addClass("nav-open");
      $(".header").addClass("header-absolute");
    }
  });

  // Close drawer on desktop
  hamburgerClose.on("click", function () {
    icons.removeClass("icons-animate");
    hamburger.removeClass("active");
  });

  //dropdown menu on click
  var navLink = $(".main-nav > li.has-submenu span.first-menu-span");
  var dropDown = $(".sub-menu");
  showSubMenusOnMobile(navLink, dropDown);

  //subdropdown menu on click
  var navLinkSub = $(".sub-menu > li.has-dropdown-submenu  span.second-menu-span");
  var dropDownSub = $(".has-dropdown-menu");
  showSubMenusOnMobile(navLinkSub, dropDownSub);

  function showSubMenusOnMobile(links, dropdowns) {
    links.on("click", function () {
      if ($(this).next(dropdowns).is(":visible")) {
        $(this).removeClass("active");
        $(this).next(dropdowns).slideUp();
      } else {
        $(links).removeClass("active");
        $(this).addClass("active");
        $(links).next(dropdowns).slideUp();
        $(this).next(dropdowns).slideToggle();
      }
    });
  }

  // show form on button click
  $("#show-form").on("click", function (e) {
    e.preventDefault();
    $(".animated-form").toggleClass("active");
  });

  //Show call icons
  $(".call-icon").on("click", function () {
    if ($(this).hasClass("active-icon")) {
      $(".call-icon").removeClass("active-icon");
    } else {
      $(this).addClass("active-icon");
    }
    $(".call-icons-list").toggleClass("active");
  });

  // Add smooth scrolling to all links
  $("a").on("click", function (event) {
    if (this.hash !== "") {
      event.preventDefault();
      var hash = this.hash;

      $("html, body").animate(
        {
          scrollTop: $(hash).offset().top,
        },
        800,
        function () {
          window.location.hash = hash;
        }
      );
    }
  });


  const imageGallery = $(".my-gallery");
  if(imageGallery) {
    let lightbox = new PhotoSwipeLightbox({
      gallery: ".my-gallery",
      children: "a",
      showHideAnimationType: "none",
      pswpModule: PhotoSwipe,
    });
    lightbox.init();
  }

    //Contact form valitadion
    $("#contact_form").validate({
      // Rules for form validation
      rules: {
        name: {
          required: true,
        },
        surname: {
          required: true,
        },
        email: {
          required: true,
          email: true,
        },

      },
  
      // Messages for form validation
      messages: {
        name: {
          required: "Please enter first name",
        },
        surname: {
          required: "Please enter surname",
        },
  
        email: {
          required: "Please enter your email address",
        },
      },
    });

  //Contact form valitadion
  $("#included_form").validate({
    // Rules for form validation
    rules: {
      name: {
        required: true,
      },
      email: {
        required: true,
        email: true,
      },

      terms2: {
        required: true,
      },
    },

    // Messages for form validation
    messages: {
      name: {
        required: "Please enter first name",
      },
      surname: {
        required: "Please enter surname",
      },

      email: {
        required: "Please enter your email address",
      },
      terms: {
        required: "Please accept our policy",
      },
    },
  });

  //Booking Contact form valitadion
  $("#booking_contact_form").validate({
    // Rules for form validation
    rules: {
      name: {
        required: true,
      },
      email: {
        required: true,
        email: true,
      },
      message: {
        required: true,
      },

      policyCheck: {
        required: true,
      },
    },

    // Messages for form validation
    messages: {
      name: {
        required: "Please enter first name",
      },
      message: {
        required: "Please enter message",
      },

      email: {
        required: "Please enter your email address",
      },
      termsCheck: {
        required: "Please accept our policy",
      },
      policyCheck: {
        required: "Please accept our policy",
      },
    },
  });
});

//scroll from top and change header style
$(window).scroll(function () {
  if ($(window).scrollTop() > 150) {
    $(".header-home").addClass("header-shrink");
    $(".header_top").addClass("remove");
  } else {
    $(".header-home").removeClass("header-shrink");
    $(".header_top").removeClass("remove");
  }
});

//scroll to top  button
let calculateScrollValue = () => {
  let progress = $(".scroll-progress");
  let pos = $(window).scrollTop();
  let calcHeight = $(document).height() - $(window).height();
  let scrollValue = Math.round((pos * 100) / calcHeight);

  if (pos > 100) {
    progress.addClass("show-progress");
  } else {
    progress.removeClass("show-progress");
  }

  progress.on("click", function () {
    $(window).scrollTop(0);
  });

  progress.css("background", `conic-gradient(#020f38 ${scrollValue}%, #3c91f9 ${scrollValue}%)`);
};

$(window).on("scroll", function () {
  calculateScrollValue();
});

document.addEventListener("DOMContentLoaded", function () {
  /*Cookies popup window*/
  setTimeout(function () {
    $("#cookieConsent").fadeIn(400);
  }, 3000);
  $("#closeCookieConsent, .cookieConsentOK").click(function () {
    $("#cookieConsent").fadeOut(400);
  });

  //Getting page information
  let current_url = window.location.href;

  //Get icon ids
  let facebook = document.getElementById("fb");
  let linkedin = document.getElementById("linkedin");
  let whatsapp = document.getElementById("whatsapp");
  //Facebook
  facebook?.addEventListener("click", function () {
    let fb_shareUrl = "https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(current_url);
    let window_size = "width=565,height=569";
    window.open(fb_shareUrl, "", "menubar=no,resizeable=yes,scrollbars=yes," + window_size);
    return false;
  });

  //likedin
  linkedin?.addEventListener("click", function () {
    window.open("http://www.linkedin.com/shareArticle?mini=true&url=" + encodeURIComponent(current_url), "", "left=0,top=0,width=650,height=420,personalbar=0,toolbar=0,scrollbars=0,resizable=0");
    return false;
  });

  //whatsapp
  whatsapp?.addEventListener("click", function () {
    var url = encodeURIComponent(current_url);
    var message = encodeURIComponent("Check out this blog post!");
    window.location.href = "whatsapp://send?text=" + message + "%20" + url;
  });

  //Print document
   document.getElementById("btnPrint")?.addEventListener("click", function () {
    printElement(document.getElementById("printThis"));
  });

  function printElement(elem) {
    var domClone = elem.cloneNode(true);

    var $printSection = document.getElementById("printSection");

    if (!$printSection) {
      var $printSection = document.createElement("div");
      $printSection.id = "printSection";
      document.body.appendChild($printSection);
    }

    $printSection.innerHTML = "";
    $printSection.appendChild(domClone);
    window.print();
  }
 

  //accrodion scroll to beginning of content on click

  let accordionWrapper = document.querySelectorAll(".accordion-faq");
  let header = document.querySelector(".header");

  accordionWrapper.forEach(function (wrap) {
    let accrdionItem = wrap.querySelectorAll(".collapse");

    accrdionItem.forEach(function (item) {
      item.addEventListener("shown.bs.collapse", function () {
        let headerHeight = header.getBoundingClientRect().height;

        let scrollOffsetAcc = wrap.scrollTop + item.parentNode.offsetTop - headerHeight;

        window.scrollTo({ top: scrollOffsetAcc, behavior: "smooth" });
      });
    });
  });

  //hover tool tip on extras
  let allTooltips = document.querySelectorAll(".equipment-img");

  allTooltips.forEach(function (el) {
    el.addEventListener("mouseenter", function () {
      allTooltips.forEach(function (e) {
        let toolTip = e.querySelector(".tooltip");
        toolTip.classList.add("hidden");
        toolTip.classList.remove("show");
      });
      this.querySelector(".tooltip").classList.add("show");
    });

    el.addEventListener("mouseleave", function () {
      allTooltips.forEach(function (e) {
        let toolTip = e.querySelector(".tooltip");
        toolTip.classList.add("hidden");
        toolTip.classList.remove("show");
      });
      this.querySelector(".tooltip").classList.add("hidden");
    });

    el.addEventListener("click", function () {
      el.children[0].classList.toggle("show");
    });
  });

  //limit text in the yacht cabins
  let dataCabins = document.querySelectorAll(".data-cabins");
  dataCabins.forEach((item) => {
    let newText = item.innerText.slice(0, 2);
    item.innerHTML = newText;
  });


  // TINY SWIPER
  // TINY SWIPER - Support Multiple .yachts-slider Elements
function initSwipers(slidesPerView) {
  const yachtSliders = document.querySelectorAll(".yachts-slider");
  const swipers = [];

  yachtSliders.forEach((slider) => {
      swipers.push(new Swiper(slider, {
          spaceBetween: 20,
          slidesPerView: slidesPerView,
          pagination: {
              el: slider.querySelector('.swiper-pagination'),
              clickable: true,
          },
          navigation: {
              nextEl: slider.querySelector('.swiper-button-next'),
              prevEl: slider.querySelector('.swiper-button-prev'),
          },
      }));
  });

  return swipers;
}

const breakpoint = window.matchMedia('(min-width: 992px)');

let swiperInstances = [];

function handleBreakpointChange() {
  swiperInstances.forEach(instance => instance.destroy()); // Destroy existing instances
  swiperInstances = []; // Clear the array

  if (breakpoint.matches) {
      swiperInstances = initSwipers(4);
  } else {
      swiperInstances = initSwipers(1);
  }
}

breakpoint.addEventListener('change', handleBreakpointChange);

// Initialize on load
handleBreakpointChange();


});
// END TINY SWIPER

//show btn on image mouse over
const sections = document.querySelectorAll(".routes-wrapper");
sections?.forEach((section)=> {
  const btnSection = section.querySelector(".btn-show-more");

  section.addEventListener('mouseenter', () => {
    btnSection.style.visibility = "visible"
  });

  section.addEventListener('mouseleave', () => {
    btnSection.style.visibility = "hidden"
  });

  section.addEventListener('mousemove', (e) => {

    const mouseX = e.clientX;
    const mouseY = e.clientY;

    const sectionRect = section.getBoundingClientRect();
    const offsetX = mouseX - sectionRect.left;
    const offsetY = mouseY - sectionRect.top;

    btnSection.style.transform = `translate3d(${offsetX}px,${offsetY}px,0)`

  })
});